import { getCurrentTime } from '@/lib/dev-clock';
import { fetchPublishedEvents, type Event } from '@/lib/events';
import { rankHomeFeedEvents } from '@/lib/home-feed';
import { selectLandingEvent } from '@/lib/landing-event-core';
import { fetchRouteVersion, type RouteLibraryItem } from '@/lib/routes';
import { DEFAULT_TENANT_SLUG, fetchTenantBySlug, type Tenant } from '@/lib/tenant';

export type LandingEventData = Readonly<{
  event: Event | null;
  route: RouteLibraryItem | null;
  tenant: Tenant | null;
}>;

export async function fetchLandingEvent(): Promise<LandingEventData> {
  const tenant = await fetchTenantBySlug(DEFAULT_TENANT_SLUG);
  if (!tenant) return { event: null, route: null, tenant: null };

  const publishedEvents = await fetchPublishedEvents(tenant.id);
  const rankedEvents = rankHomeFeedEvents(publishedEvents, getCurrentTime());
  const event = selectLandingEvent(rankedEvents, tenant.timezone);
  const route = event?.route_version_id ? await fetchRouteVersion(event.route_version_id) : null;
  return { event, route, tenant };
}
